module.exports = __webpack_public_path__ + "static/pagination-65ad2c173f869ac5f83eb17d8c74cc31.gif";